var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meta-item"},[_c('div',{staticClass:"wrapper"},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":[this.icon.prefix, this.icon.iconName]}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }